module.exports = __webpack_public_path__ + "media/6.1e0a399c.mp3";